module.exports = __webpack_public_path__ + "img/digital_art_1920_1080_mit_wasserzeichen_20.131ab77b.jpg";